module.exports = __webpack_public_path__ + "static/media/09.839db240.jpg";